export const RAG_ADMIN_ROLE_CODE = "rag_admin";
export const PLATFORM_ADMIN_HOME = "/admin/model-catalog";
export const RAG_ADMIN_HOME = "/admin/rag/materials";

export function isPlatformAdmin(user) {
  return !!(user && user.is_platform_admin);
}

export function hasPlatformRole(user, roleCode) {
  const normalizedRoleCode = String(roleCode || "").trim();
  return !!(
    normalizedRoleCode
    && user
    && Array.isArray(user.platform_role_codes)
    && user.platform_role_codes.includes(normalizedRoleCode)
  );
}

export function isRagAdmin(user) {
  return hasPlatformRole(user, RAG_ADMIN_ROLE_CODE);
}

export function canAccessAdminConsole(user) {
  return isPlatformAdmin(user) || isRagAdmin(user);
}

export function canAccessAdminRoute(user, requiredPlatformRole = "") {
  if (isPlatformAdmin(user)) {
    return true;
  }
  const roleCode = String(requiredPlatformRole || "").trim();
  return !!roleCode && hasPlatformRole(user, roleCode);
}

export function adminDefaultPath(user) {
  if (isPlatformAdmin(user)) {
    return PLATFORM_ADMIN_HOME;
  }
  if (isRagAdmin(user)) {
    return RAG_ADMIN_HOME;
  }
  return "/home";
}
